"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChoiceWithMaximum = void 0;
const isChoiceWithMaximum = (choice) => choice.remainingCapacity !== undefined &&
    choice.remainingCapacity !== null &&
    choice.maximum !== undefined &&
    choice.maximum !== null;
exports.isChoiceWithMaximum = isChoiceWithMaximum;
